<template>
  <section class="gallery">
    <div class="main-image half">
      <img src="" alt="" />
      <h4 id="main-caption"></h4>
    </div>

    <div class="gallery-thumbnails half">
      <div class="thumbnail u-size1of4 active">
        <img src="https://via.placeholder.com/300/ffdfff/000000" alt="1" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/34cf4f/000000" alt="2" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/f5839f/000000" alt="3" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/0254cd/000000" alt="4" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/ee345e/000000" alt="5" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/012e3c/000000" alt="6" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/fff000/000000" alt="7" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/0254cd/000000" alt="8" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/ee345e/000000" alt="9" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/012e3c/000000" alt="10" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/fff000/000000" alt="11" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/34cf4f/000000" alt="12" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/f5839f/000000" alt="13" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/0254cd/000000" alt="14" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/ee345e/000000" alt="15" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/012e3c/000000" alt="16" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/fff000/000000" alt="17" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/0254cd/000000" alt="18" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/ee345e/000000" alt="19" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/012e3c/000000" alt="20" />
      </div>
      <div class="thumbnail u-size1of4">
        <img src="https://via.placeholder.com/300/012e3c/000000" alt="20" />
      </div>
      <!-- <div class="arrows u-md-hide">
      <span class="page-btn previous"><</span>
      <span class="pagenation "></span>
      <span class="page-btn forward">></span>
      <input type="hidden" value="" id="page" />
    </div> -->
    </div>
  </section>
</template>
<script>
export default {
  name: "attachments",
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {
      
  },
  async created() {},
};
</script>
<style lang="scss">
.page-btn {
  cursor: pointer;
  border: 1px solid black;
  padding: 2px 5px;
}

.gallery {
  max-width: 1240px;
  margin: 50px auto;
  width: 100%;
  @media (min-width: 800px) {
    display: flex;
  }
  .half {
    @media (min-width: 800px) {
      width: 48%;
      padding: 0 1%;
    }
    position: relative;
  }
}

.gallery-thumbnails {
  @media (max-width: 800px) {
    overflow: auto;
    white-space: nowrap;
  }
}
.u-size1of4 {
  width: calc(24% - 20px);
  padding: 10px;
}
img {
  width: 100%;
  height: auto;
}
.thumbnail {
  cursor: pointer;
  &:not(.active) {
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
}

.pageNum {
  margin: 0 10px;
  cursor: pointer;
  &.active {
    color: blue;
  }
}

.u-md-hide {
  @media (max-width: 800px) {
    display: none;
  }
}
</style>
